import { createFileRoute } from '@tanstack/react-router';
import { AdminPageSeoView } from '@/components/admin/AdminPageSeoView';

export const Route = createFileRoute('/_authed/admin/page-seo/')({
  component: AdminPageSeoView,
});
